import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
};
export const callTypes = {
  list: "list",
  action: "action",
};
//State işlemleri için
export const Slice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.err}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.actionsLoading = false;
      } else {
        state.actionsLoading = false;
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
        state.actionsLoading2 = true;
      }
    },
    getUsers: (state, action) => {
      state.error = null;
      state.users = action.payload;
    },
    editUser: (state, action) => {
      state.error = null;
      const index = state.users.findIndex(user => user._id === action.payload._id);
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    
  },
});
